const getSelectors = state => ({
  getAllToasts() {
    return state.toasts
  }
})

export default getSelectors
